import { useUserRole } from "@/api";
import { PartialApp } from "../types/app.type";

export function useRenderAppActions(app: PartialApp) {
  const { isAdmin } = useUserRole();

  const renderForOrganizationApp = app.origin === "organization" && isAdmin;
  const renderForSubscriptionApp =
    app.origin === "subscription" && isAdmin && app.defaultDeployment?.apiURL;

  return renderForOrganizationApp || renderForSubscriptionApp;
}
